import { defineStore } from 'pinia'

export const useYoutubeTimelineStore = defineStore('youtube-timeline', () => {
  const positions = reactive<Record<string, number>>({})

  function getPosition(videoId: string): number {
    return positions[videoId] ?? 0
  }

  function setPosition(videoId: string, seconds: number) {
    positions[videoId] = seconds
  }

  return {
    positions,
    getPosition,
    setPosition,
  }
})
